/**
 * 遮罩
 */
L.Mask = L.Polygon.extend({
    options: {
        isRect: true, //是否为矩形遮罩,如果为是,则使用northWest，northEast，sourthEast，sourthWest创建矩形遮罩层外边界,如果为false，则使用传入的坐标数组作为遮罩层外边界
        northWest: { lat: 180.0, lng: -180.0 }, //遮罩层西北角坐标
        northEast: { lat: 180.0, lng: 180.0 }, //遮罩层东北角坐标
        sourthEast: { lat: -180.0, lng: 180.0 }, //遮罩层东南角
        sourthWest: { lat: -180.0, lng: -180.0 }, //遮罩层西南角
        maskBoundary: null, //遮罩层边界坐标
        showPolygons: [] //显示区域
    },
    initialize(options) {
        L.Util.setOptions(this, options);
        console.log(this);
        let latlngs = this.getMaskLatLngs();
        this._setLatLngs(latlngs);
    },
    /**
     * 画遮蔽层的相关方法
     *思路: 创建一个矩形作为遮罩层,构造函数传入的坐标作为内环
     * @see https://blog.csdn.net/mapmonster/article/details/104455516
     * 
     * @param {*} latlngs 
     */
    getMaskLatLngs() {
        let latlngs = [];
        //是矩形遮罩,则使用northWest，northEast，sourthEast，sourthWest创建矩形遮罩层外边界
        if (this.options.isRect) {
            this.options.maskBoundary = [];
            this.options.maskBoundary.push(this.options.northWest);
            this.options.maskBoundary.push(this.options.sourthWest);
            this.options.maskBoundary.push(this.options.sourthEast);
            this.options.maskBoundary.push(this.options.northEast);
            this.options.maskBoundary.push(this.options.northWest);
        }
        latlngs.push(this.options.maskBoundary);
        for (let i = 0; i < this.options.showPolygons.length; i++) {
            latlngs = latlngs.concat(this.options.showPolygons[i].getLatLngs());
        }
        return latlngs;
    }
});

/**
 * 合乎leaflet语法
 * @param {*} options 
 * @returns 
 */
L.mask = function(latlngs, options) {
    return new L.Mask(latlngs, options);
};